<template>
    <div class="scfForm">
        <div class="campusForm">
            <h1 class="scfTitleBorder">
                {{ model.resource.name }}
            </h1>
            <div class="scfIntroBorder">
                <p>
                    <div>
                        <span>
                            {{ model.resource.address }} in {{ model.resource.city }}
                        </span>
                        <span v-if="model.resource.floor">
                            {{ getTranslation('camp_raum_OnFloor') }} {{ model.resource.floor }}
                        </span>
                    </div>
                    <div v-if="model.resource.description">
                        {{ getTranslation('camp_raum_ResourceDescription') }}: {{ model.resource.description }}
                    </div>
                    <div v-if="model.resource.roomType">
                        {{ getTranslation('camp_edu_RaumType') }}: {{ model.resource.roomType }}
                    </div>

                    <br />

                    <div v-if="model.resource.roomEquipment.length !== 0" class="append-bottom">
                        <div :aria-expanded="component.showEquipment">
                            <a @click.prevent="toggleShowEquipment">
                                <span>
                                    {{ getTranslation('camp_raum_Equipment') }}:
                                </span>
                                <span v-show="!component.showEquipment">
                                    ({{ getTranslation('camp_More') }})...
                                </span>
                                <i class="icon-toggle"></i>
                            </a>
                        </div>
                        <ul v-show="component.showEquipment">
                            <li v-for="roomEquipmentEntry in model.resource.roomEquipment" class="prepend-left">
                                {{ roomEquipmentEntry }}
                            </li>
                        </ul>
                    </div>

                    <div>
                        {{ model.resource.bookingTypeName }}
                    </div>
                    <div>
                        {{ getTranslation('camp_date') }}: {{ model.date.dateStr }}
                    </div>
                    <div v-for="bookableSpot in model.bookableSpots">
                        {{ getTranslation('camp_raum_BookableTime') }}: {{ bookableSpot }}
                    </div>
                    <div v-if="model.durationInMinutesMax">
                        {{ getTranslation('camp_raum_MaxDuration') }}: {{ model.durationInMinutesMax }} {{ getTranslation('camp_raum_Minutes') }}
                    </div>
                </p>
            </div>
            <div>
                <div>
                    <fieldset class="scfSectionBorderAsFieldSet">
                        <div class="scfSectionContent">

                            <div class="scfSingleLineTextBorder">
                                <label for="fromHour" class="scfSingleLineTextLabel">
                                    {{ getTranslation('camp_raum_TimeFrom') }}:
                                    *
                                </label>
                                <div class="scfSingleLineGeneralPanel">
                                    <input id="fromHour" type="text" v-model="fromHour" size="3" maxlength="2" inputmode="numeric" class="scfSingleLineTextBox timeBox" required />
                                    :
                                    <input id="fromMinute" type="text" v-model="fromMinute" size="3" maxlength="2" inputmode="numeric" class="scfSingleLineTextBox timeBox" required />
                                </div>
                            </div>

                            <div class="scfSingleLineTextBorder">
                                <label for="toHour" class="scfSingleLineTextLabel">
                                    {{ getTranslation('camp_raum_TimeUntil') }}:
                                    *
                                </label>
                                <div class="scfSingleLineGeneralPanel">
                                    <input id="toHour" type="text" v-model="toHour" size="3" maxlength="2" inputmode="numeric" class="scfSingleLineTextBox timeBox" required />
                                    :
                                    <input id="toMinute" type="text" v-model="toMinute" size="3" maxlength="2" inputmode="numeric" class="scfSingleLineTextBox timeBox" required />
                                </div>
                            </div>

                            <div class="scfSingleLineTextBorder">
                                <label for="title" class="scfSingleLineTextLabel">
                                    {{ getTranslation('camp_raum_TitleOfBooking') }}:
                                    *
                                </label>
                                <div class="scfSingleLineGeneralPanel">
                                    <input id="title" type="text" v-model="title" size="40" maxlength="40" class="scfSingleLineTextBox" required />
                                </div>
                            </div>

                            <div class="scfCheckboxBorder" v-if="model.canBookDevices">
                                <div class="scfCheckBoxListGeneralPanel">
                                    <span class="scfCheckbox">
                                        <input id="bookDevices" type="checkbox" v-model="component.bookDevices" />
                                        <label for="bookDevices">
                                            {{ getTranslation('camp_raum_BookDevicesQuestion') }}
                                        </label>
                                    </span>
                                </div>
                            </div>

                            <div class="scfCheckboxBorder">
                                <div class="scfCheckBoxListGeneralPanel">
                                    <span class="scfCheckbox">
                                        <input id="conditionsAccepted" type="checkbox" v-model="component.conditionsAccepted" />
                                        <label for="conditionsAccepted">
                                            {{ getTranslation('camp_raum_AcceptConditions1') }}
                                            <a v-bind:href="additional.conditionsLink" target="_blank">
                                                {{ getTranslation('camp_raum_AcceptConditions2') }}
                                            </a>
                                            {{ getTranslation('camp_raum_AcceptConditions3') }}
                                            *
                                        </label>
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div class="scfSectionContent">

                            <div class="scfSingleLineTextBorder">
                                {{ getTranslation('camp_raum_NameDisplayWarning') }}
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="scfSubmitButtonBorder">
                <input type="submit" :value="getTranslation('camp_edu_Save')" @click.prevent="save" class="scfSubmitButton" />
                <a href="javascript:window.history.back()" class="button">{{ getTranslation('camp_Cancel') }}</a>
            </div>
        </div>
    </div>
</template>
<script>
    import RaumResResourceBooking from "../../../../_Api/RaumResResourceBooking";

    export default {
        name: 'Step1MainBooking',
        props: {
            model: null,
            additional: null
        },
        data() {
            return {
                "component": {
                    "bookDevices": false,
                    "conditionsAccepted": false,
                    "showEquipment": false
                }
            }
        },
        methods: {
            save() {
                if (!this.fromHour
                    || !this.fromMinute
                    || !this.toHour
                    || !this.toMinute
                    || !this.title) {
                    var msg = this.getTranslation('camp_RequiredFieldMessageBox');
                    dialogError(msg);
                    return;
                }
                if (!this.component.conditionsAccepted) {
                    var msg = this.getTranslation('camp_raum_PleaseAgreeToTheConditions');
                    dialogError(msg);
                    return;
                }
                var query = {
                    "resourceId": this.model.resource.id,
                    "date": this.model.date.date,
                    "fromHour": this.fromHour,
                    "fromMinute": this.fromMinute,
                    "toHour": this.toHour,
                    "toMinute": this.toMinute,
                    "title": this.title
                };
                RaumResResourceBooking.saveBooking(query, this.saveRoomSuccess, this.saveRoomFailure);
            },
            getTranslation(key) {
                return this.model.translations[key];
            },
            saveRoomSuccess(data) {
                if (data.successful) {
                    dialogInfo(data.message, null, this.doRedirect);
                }
                else {
                    dialogError(data.message);
                }
            },
            saveRoomFailure(status) {
                dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
            },
            doRedirect() {
                if (this.component.bookDevices) {
                    this.$router.push("device");
                } else {
                    window.location = this.additional.redirectUrl;
                }
            },
            toggleShowEquipment() {
                this.component.showEquipment = !this.component.showEquipment;
            }
        },
        computed: {
            fromHour: {
                get() {
                    return this.$store.getters.getFromHour
                },
                set(value) {
                    this.$store.commit('setFromHour', value)
                }
            },
            fromMinute: {
                get() {
                    return this.$store.getters.getFromMinute
                },
                set(value) {
                    this.$store.commit('setFromMinute', value)
                }
            },
            toHour: {
                get() {
                    return this.$store.getters.getToHour
                },
                set(value) {
                    this.$store.commit('setToHour', value)
                }
            },
            toMinute: {
                get() {
                    return this.$store.getters.getToMinute
                },
                set(value) {
                    this.$store.commit('setToMinute', value)
                }
            },
            title: {
                get() {
                    return this.$store.getters.getTitle
                },
                set(value) {
                    this.$store.commit('setTitle', value)
                }
            }
        }
    }
</script>
<style scoped lang="scss">
@import "~/Assets/Campus/Common/sass/colors";
    .timeBox {
        width: auto !important;
        display: inline !important;
    }

    input:required:invalid {
        border-color: $error-color;
    }
</style>